import { render } from "./commentMs.vue?vue&type=template&id=6e63d844"
import script from "./commentMs.vue?vue&type=script&lang=js"
export * from "./commentMs.vue?vue&type=script&lang=js"

import "./commentMs.vue?vue&type=style&index=0&id=6e63d844&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__